import { http } from "../../../config/HttpMethod";
import { DepletionCurveGraphData, DepletionCurvePayload, DepletionPercentageInObject, FutureBHPInObject, InflowData, IPRGraphData, IPRGraphPayload, IPRTableData, TdhCalculations } from "../../../store/model/calculations/calculation";
import { ESP_ENDPOINTS } from "../endpoints";

// Add this interface
export interface TailPipe {
    tailPipeDesander: number;
    transitionZone: number;
    tailPipeBttm: number;
}

export const getInflowData = async (wellId: number): Promise<InflowData | null> => {
    try {
        const response = await http.post<InflowData>(`${ESP_ENDPOINTS?.GET_INFLOW_CALCULATIONS}`, { wellId });
        return response?.data || null;
    } catch (err) {
        console.error("Error fetching inflow data:", err);
        return null;
    }
};
// Async API Call for IPR Data

export const getIPRTableData = async (postData: (string | number | null | undefined)[]): Promise<IPRTableData | null> => {
    try {
        const response = await http.post<IPRTableData>(`${ESP_ENDPOINTS?.GET_IPR_DATA}`, postData);
        return response?.data || null;
    } catch (err) {
        console.error("Error fetching TDH data:", err);
        return null;
    }
};
export const getTDHData = async (postData: (string | number | null | undefined)[]): Promise<TdhCalculations | null> => {
    try {
        const response = await http.post<TdhCalculations>(`${ESP_ENDPOINTS?.GET_TDH_DATA}`, postData);
        return response?.data || null;
    } catch (err) {
        console.error("Error fetching TDH data:", err);
        return null;
    }
};
export const getDepletionCurveData = async (postData: DepletionCurvePayload) => {
    try {
        const response = await http.post<DepletionCurveGraphData>(
            `${ESP_ENDPOINTS?.GET_DEPLETION_GRAPH_DATA}`, postData
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching Depletion Curve Data", err);
        return null;
    }
};
export const getIPRGraphData = async (postData: IPRGraphPayload): Promise<IPRGraphData | null> => {
    try {
        const response = await http.post<IPRGraphData>(`${ESP_ENDPOINTS?.GET_IPR_GRAPH_DATA}`, postData);
        return response?.data || null;
    } catch (err) {
        console.error("Error fetching IPR Graph Data:", err);
        return null;
    }
};

export const GetDepletionPercentage = async (depletionPercentageInObject: DepletionPercentageInObject) => {
    try {
        const response = await http.post<number>(`${ESP_ENDPOINTS?.GET_DEPLETION_PERCENTAGE}`, depletionPercentageInObject);
        return response?.data;
    } catch (err) {
        console.error("Error fetching Depletion Percentage:", err);
    }
};

export const GetFutureBHP = async (futureBHPObject: FutureBHPInObject) => {
    try {
        const response = await http.post<number>(`${ESP_ENDPOINTS?.GET_FUTURE_BHP}`, futureBHPObject);
        return response?.data;
    } catch (err) {
        console.error("Error Fetching Future BHP:", err);
    }
};

export const CallNewTDH = async (postData: (string | number)[]) => {
    try {
        const response = await http.post<any>(`${ESP_ENDPOINTS?.GET_NEW_TDH}`, postData);
        return response?.data;
    } catch (err) {
        console.error("Error calling New TDH:", err);
    }
};

export const basicCalculationService = {
    getTailPipeTZ: async (postData: any) => {
        try {
            const response = await http.post(`${ESP_ENDPOINTS?.GET_TAIL_PIPE_TZ}`, postData);
            return response.data;
        } catch (error) {
            console.error('Error calculating TailPipe TZ:', error);
            return 0;
        }
    }
   
};

// Add this new export
export const getTailPipeTZ = async (postData: TailPipe): Promise<number> => {
    try {
        const response = await http.post<number>(`${ESP_ENDPOINTS?.GET_TAIL_PIPE_TZ}`, postData);
        return response?.data || 0;
    } catch (err) {
        console.error("Error calculating Tail Pipe TZ:", err);
        return 0;
    }
};